export const safeWrap = (str: string) => <span className="text-pre-wrap">{str}</span>;
